// Cliente da API com bearer (backend de auth), Accept-Language (i18n atual) e X-Purpose (propósito vigente).
import { type GiyusClient, createGiyusClient } from '@giyus/api-client';

import type { AuthBackend } from '../auth/types';
import { readValidPurpose } from '../purpose/purposeStore';

export function buildApiClient(
  baseUrl: string,
  backend: AuthBackend,
  getLocale: () => string,
): GiyusClient {
  return createGiyusClient({
    baseUrl,
    getLocale,
    getAccessToken: () => backend.getAccessToken(),
    getPurpose: readValidPurpose,
    ...(backend.notifySessionLost ? { onUnauthorized: backend.notifySessionLost } : {}),
    ...(backend.fetch ? { fetch: backend.fetch } : {}),
  });
}
